module.exports = __webpack_public_path__ + "img/price-click-4.207d2844.webp";